export function openFilter() {
	if (document.querySelector('#filter-icon') && document.querySelector('#filter-section .filter:not(.show-filter-mobile)')) {
		document.querySelector('#filter-icon').addEventListener('click', function () {
			document.querySelector('body').classList.toggle('filter--open')
			const focusItem = document.querySelector('#filter-section').querySelector(':is(a, button, input, select, textarea):not([tabindex="-1"], [type="hidden"])')
			if (focusItem) focusItem.focus()
		})
	}

	if (document.querySelector('.search-button') && document.querySelector('#filter-section .filter:not(.show-filter-mobile)')) {
		document.querySelectorAll('.search-button').forEach((button) => {
			button.addEventListener('click', function () {
				document.querySelector('body').classList.toggle('filter--open')
				document.querySelector('#listing').scrollIntoView()
			})
		})
	}

	if (document.querySelectorAll('.button--filter').length == 1 && document.querySelector('#filter-section .filter:not(.show-filter-mobile)')) {
		document.querySelector('.button--filter').addEventListener('click', function () {
			document.querySelector('body').classList.remove('filter--open')
			scrollTo(0, 0)
		})
	}
}
